import React, {useEffect, useState} from 'react';
import {DetailGrid, Utility} from '@/components/GridWidget';
import {NsGrid} from '@/components/GridWidget/GridDefProps';
import {WdiCardTitle, wdiCore, WdiModalProps} from '@/components/WdiControls';
import {Button, Input} from 'antd';
import {initFieldDisplayFormater, TableColumnRanderFormats} from '@/components/WdiBus/TableColumnRanderFormats'
import {WdiPanel} from '@/components/WdiControls/WdiPanel';
import {WdiInputNumber} from '@/components/WdiControls/WdiInputNumber';
import DataStore from '@/components/GridWidget/DataStore';
import {ImportModalApp} from '@/components/WdiControls/WdiImport';
import {Enum} from '@/enums/system';
import {GridApi} from '@/services/gridapi';
import {FormSs} from '@/services/sales/ss';
import {GroupDetailGrid} from '@/components/GridWidget/GroupDetailGrid';
import SettleDetailEditApp from "@/pages/sales/ss/GeneralSettleApply/components/detail-edit";
import {Position} from '@/services/basic/position';
import {ResponseStatus} from '@/utils/request';
import {getAllHasValueColumns} from '@/pages/sales/sa/components/data';
import {FieldConfigUtility, getEcDefFields} from "@/components/WdiBus/EcFieldConfig";
import {getSchemaColumns, toExcel} from "@/components/WdiControls/WdiExcel";
import {replaceColumns} from "@/pages/sales/ss/components/data";

export type DetailForApplyProps = {
  data?: any,
  dataSource: any[],
  onChange?: (dataSource: any) => void,
}

export const initRowFieldConfigs = (record: any, ecFieldConfigs: API.EcFieldConfig[] | undefined) => {
  const columns = ["soldToCode", "shipToCodes", "productBuyIds", "ecId", "amountSa", "amountActual", "amount", "remark"
    , "amountPaid"];

  if (!wdiCore.Object.IsNullOrUndefined(record.amountStatement)) {
    columns.push("amountStatement");
  }
  columns.push("revenueSellinActual");
  if (!wdiCore.Object.IsNullOrUndefined(record.displayAreaActual)) {
    columns.push("displayAreaActual");
  }
  if (!wdiCore.Object.IsNullOrUndefined(record.revenuePosActual)) {
    columns.push("revenuePosActual");
  }
  columns.push("custSysCode", "paymentMethodId", "boId", "activityStartDate", "activityEndDate", "supplyStartDate", "supplyEndDate",
    "remarkSa", "formSaDetailId", "syncStatus");
  if (ecFieldConfigs && ecFieldConfigs.length > 0) {
    if (record.extendFieldsSa || record.revExtendFieldsSa) {
      columns.push(...getEcDefFields(ecFieldConfigs, FieldConfigUtility.merge(record.extendFieldsSa, record.revExtendFieldsSa)));
    }
  }
  columns.push(...getAllHasValueColumns(record));
  if (!wdiCore.Object.IsNullOrUndefined(record.revenueType)) {
    columns.push("revenueType");
  }
  return columns;
};

const GeneralSettleDetailsForApplyApp: React.FC<DetailForApplyProps> = (props) => {
  /// Grid初始化配置，GridSettings请求完数据之后再进行加载
  const [isLoaded, setIsLoaded] = useState(false);
  const [gridSettings, setGridSettings] = useState<any>({});
  const [importModalProps, setImportModalProps] = useState<WdiModalProps>({visible: false});
  const {data, onChange} = props;
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [modalProps, setModalProps] = useState<WdiModalProps>({visible: false});

  const onImportClose = () => {
    setImportModalProps({visible: false, title: "", id: null});
  }
  const onImportSave = (uploadResult: any) => {
    const newDataSource = [...dataSource];
    const result = uploadResult?.data?.data;
    if (result && result.length > 0) {
      newDataSource.forEach(record => {
        const item = result.find((item: any) => item.formSaDetailId == record.formSaDetailId);
        record.quantityPosActualKeyin = wdiCore.Number.ToNumber(item?.quantityPosActualKeyin, 2);
        record.revenuePosActualKeyin = wdiCore.Number.ToNumber(item?.revenuePosActualKeyin, 2);
        record.quatitySs = wdiCore.Number.ToNumber(item?.quatitySs, 2);
        record.amount = wdiCore.Number.ToNumber(item?.amount, 2);
        record.remark = item?.remark;
      })
      onChange?.(newDataSource);
    }
    setImportModalProps({visible: false, title: "", id: null});
  }
  useEffect(() => {
    if (!props.data.formSaId) return;
    GridApi.searchConfig({id: 'FormSSDetailForGeneral', allowModifyColumns: true}).then((response) => {
      const settings: any = Object.assign({}, response.data, {
        actionsAlign: NsGrid.ActionsAlign.Left,
        showAggr: true,
        showExpandedRow: true,
      });
      initFieldDisplayFormater(settings.formSchema.allFields);
      settings.formSchema.allFields.activityStartDate.getDisplayFormater = (text: any, record: any, index: any) => {
        if (record.activityStartDate) {
          return record.activityStartDate;
        } else {
          return record.activityStartDateSa;
        }
      }
      settings.formSchema.allFields.activityEndDate.getDisplayFormater = (text: any, record: any, index: any) => {
        if (record.activityEndDate) {
          return record.activityEndDate;
        } else {
          return record.activityEndDateSa;
        }
      }

      settings.formSchema.allFields.supplyStartDate.getDisplayFormater = (text: any, record: any, index: any) => {
        if (record.supplyStartDate) {
          return record.supplyStartDate;
        } else {
          return record.supplyStartDateSa;
        }
      }
      settings.formSchema.allFields.supplyEndDate.getDisplayFormater = (text: any, record: any, index: any) => {
        if (record.supplyEndDate) {
          return record.supplyEndDate;
        } else {
          return record.supplyEndDateSa;
        }
      }

      settings.formSchema.allFields.amountSa.aggr = TableColumnRanderFormats.sumAggr('amountSa', 2);
      settings.formSchema.allFields.amount.aggr = TableColumnRanderFormats.sumAggr('amount', 2);
      settings.formSchema.allFields.amountActual.aggr = TableColumnRanderFormats.sumAggr('amountActual', 2);


      settings.formSchema.allFields.rowNumber.width = 50;
      settings.formSchema.allFields.soldToCode.width = 180;
      settings.formSchema.allFields.shipToCodes.width = 180;
      settings.formSchema.allFields.productBuyNames.width = 180;
      settings.formSchema.allFields.ecId.width = 120;
      settings.formSchema.allFields.amountSa.width = 100;
      settings.formSchema.allFields.amountActual.width = 100;
      settings.formSchema.allFields.amount.width = 150;
      settings.formSchema.allFields.remark.width = 150;
      if (settings.formSchema.allFields.sfaResult) {
        settings.formSchema.allFields.sfaResult.getDisplayFormater = (text: any, record: any, index: any) => {
          return (
            <a onClick={() => {
              FormSs.Buttons.getSfaResultUrl(record.formSsId, record.formSsDetailId).then(res => {
                window.open(res.data);
              });
            }}>
              查看
            </a>
          )
        };
      }

      setGridSettings(settings);
      setIsLoaded(true);
    });
  }, [props.data.formSaId]);

  useEffect(() => {
    setDataSource(props.dataSource)
  }, [props.dataSource])


  const pageGridSettings = Object.assign({}, gridSettings);
  pageGridSettings.antdProps = {
    dataSource,
    initRowFieldConfigs: (record: any) => {
      return initRowFieldConfigs(record, data.ecFieldConfigs);
    },
    pagination: {
      defaultPageSize: 10,
      showSizeChanger: true,
    },
  };

  const editColumn = {
    amount: (_t: any, record: any, index: any) => {
      return <WdiInputNumber value={record.amount} onBlur={(e: any) => {
        const {...newRecord} = record;
        newRecord.amount = wdiCore.Number.ToNumber(e.target.value, 2);
        onChange?.(DataStore.edit(dataSource, newRecord));
      }}/>
    },
    remark: (_t: any, record: any, index: any) => {
      return <Input value={record.remark} onChange={(e: any) => {
        const {...newRecord} = record;
        newRecord.remark = e.target.value;
        onChange?.(DataStore.edit(dataSource, newRecord));
      }}/>;
    }
  };
  return (
    <>
      {modalProps.visible &&
        <SettleDetailEditApp
          {...modalProps}
          onSave={(result) => {
            onChange?.(DataStore.edit(dataSource, result?.data));
            setModalProps({visible: false, data: null})
          }}
          onClose={() => setModalProps({visible: false, data: null})}
        />}
      <WdiPanel
        title={<WdiCardTitle iconType={Enum.IconType.DETAIL_INFO} title='费用明细信息'/>}
        extra={
          <Button type='primary' onClick={() => {
            setImportModalProps({title: '结案信息导入', visible: true});
          }}
                  style={{float: 'right', marginRight: 10}}>
            结案信息导入
          </Button>
        }
      >
        {
          isLoaded &&
          importModalProps.visible &&
          <ImportModalApp
            title={importModalProps.title}
            visible={importModalProps.visible}
            settingsUrl="/expenseapi/ssButtons/getImportSettings"
            uploadingUrl="/expenseapi/ssButtons/importUploading"
            onClose={onImportClose}
            onSave={onImportSave}
            clientParameters={{
              details: JSON.stringify(dataSource),
              pageTypeId: data.pageTypeId
            }}
          />
        }
        {isLoaded && <DetailGrid params={data} {...pageGridSettings} editColumn={editColumn} autoColumn={"rowNumber"}/>}
      </WdiPanel>
    </>
  );
}
export default GeneralSettleDetailsForApplyApp;

export const GeneralSettleDetailsForApprovalApp: React.FC<DetailForApplyProps> = (props) => {
  /// Grid初始化配置，GridSettings请求完数据之后再进行加载
  const [isLoaded, setIsLoaded] = useState(false);
  const [gridSettings, setGridSettings] = useState<any>({});
  const [modalProps, setModalProps] = useState<WdiModalProps>({visible: false});
  const [dataSource, setDataSource] = useState<any[]>([]);
  const {data, onChange} = props;

  useEffect(() => {
    if (!data.formSs) return;
    Promise.all([GridApi.searchConfig({id: "FormSSDetailForGeneral", allowModifyColumns: true}),
      Position.access({useCaseId: Enum.UseCase.SS, operateTypeIds: [Enum.OperateType.MODIFY_AMOUNT]})
    ]).then((dataArray: any[]) => {
      const responseResult = dataArray[0];
      const allowModifyAmountRes = dataArray[1];
      let allowModifyAmount = false
      if (allowModifyAmountRes.code == ResponseStatus.SUCCESS && allowModifyAmountRes.data == true) {
        allowModifyAmount = true;
      }

      const settings: any = Object.assign({}, responseResult.data, {
        actionsAlign: NsGrid.ActionsAlign.Left,
        showAggr: true,
        showExpandedRow: true,
      });
      initFieldDisplayFormater(settings.formSchema.allFields);
      settings.formSchema.allFields.activityStartDate.getDisplayFormater = (text: any, record: any, index: any) => {
        if (record.activityStartDate) {
          return record.activityStartDate;
        } else {
          return record.activityStartDateSa;
        }
      }
      settings.formSchema.allFields.activityEndDate.getDisplayFormater = (text: any, record: any, index: any) => {
        if (record.activityEndDate) {
          return record.activityEndDate;
        } else {
          return record.activityEndDateSa;
        }
      }

      settings.formSchema.allFields.supplyStartDate.getDisplayFormater = (text: any, record: any, index: any) => {
        if (record.supplyStartDate) {
          return record.supplyStartDate;
        } else {
          return record.supplyStartDateSa;
        }
      }
      settings.formSchema.allFields.supplyEndDate.getDisplayFormater = (text: any, record: any, index: any) => {
        if (record.supplyEndDate) {
          return record.supplyEndDate;
        } else {
          return record.supplyEndDateSa;
        }
      }


      let actions: any[] = [];
      if (settings.formSchema.actions) {
        settings.formSchema.actions.forEach((item: any) => {
          if (wdiCore.String.EqIngoreCase(item.name, "Update") && allowModifyAmount && data.formSs?.statusId == Enum.FormStatus.AWAITING) {
            Utility.setActionCallback(settings.formSchema.actions, 'Update',
              (grid: any, action: any, record: any) => {
                const context = grid.getContext();
                setModalProps({
                  title: '费用结案',
                  visible: true,
                  id: null,
                  data: {
                    isUpdate: true,
                    record: record,
                    fields: initRowFieldConfigs(record, context.params.ecFieldConfigs)
                  }
                });
              },
            );
            actions.push(item);
          }
        });
      }
      settings.formSchema.actions = actions;

      settings.formSchema.allFields.amountSa.aggr = TableColumnRanderFormats.sumAggr('amountSa', 2);
      settings.formSchema.allFields.amount.aggr = TableColumnRanderFormats.sumAggr('amount', 2);
      settings.formSchema.allFields.amountActual.aggr = TableColumnRanderFormats.sumAggr('amountActual', 2);

      settings.formSchema.allFields.rowNumber.width = 50;
      settings.formSchema.allFields.soldToCode.width = 180;
      settings.formSchema.allFields.shipToCodes.width = 180;
      settings.formSchema.allFields.productBuyNames.width = 180;
      settings.formSchema.allFields.ecId.width = 120;
      settings.formSchema.allFields.amountSa.width = 100;
      settings.formSchema.allFields.amountActual.width = 100;
      settings.formSchema.allFields.amount.width = 150;
      settings.formSchema.allFields.remark.width = 150;
      if (settings.formSchema.allFields.sfaResult) {
        settings.formSchema.allFields.sfaResult.getDisplayFormater = (text: any, record: any, index: any) => {
          return (
            <a onClick={() => {
              FormSs.Buttons.getSfaResultUrl(record.formSsId, record.formSsDetailId).then(res => {
                window.open(res.data);
              });
            }}>
              查看
            </a>
          )
        };
      }
      setGridSettings(settings);
      setIsLoaded(true);
    });
  }, [data.formSs]);

  useEffect(() => {
    setDataSource(props.dataSource)
  }, [props.dataSource])

  const pageGridSettings = Object.assign({}, gridSettings);
  pageGridSettings.antdProps = {
    dataSource,
    initRowFieldConfigs: (record: any) => {
      return initRowFieldConfigs(record, data.ecFieldConfigs).concat(["amountOriginal", "modifyReason", "modifiedUserId"]);
    },
    pagination: {
      defaultPageSize: 10,
      showSizeChanger: true
    },
  };
  return (
    <>
      {modalProps.visible &&
        <SettleDetailEditApp
          {...modalProps}
          onSave={(result) => {
            onChange?.(DataStore.edit(dataSource, result?.data));
            setModalProps({visible: false, data: null})
          }}
          onClose={() => setModalProps({visible: false, data: null})}
        />}
      <WdiPanel collapsed={true} {...props} title={<WdiCardTitle title='费用明细信息'/>}
                defaultCollapsed={false}
                extra={
                  <>
                    {data.sfaButton &&
                      <Button type='primary' onClick={(e) => {
                      }}
                              style={{float: 'right', marginRight: 10}}>
                        查看活动采集详情
                      </Button>
                    }
                    <Button type='primary' onClick={(e) => {
                      getSchemaColumns('FormSSDetailForGeneral', replaceColumns).then(columns => {
                        const sheet = {
                          data: dataSource,
                          names: columns,
                          sheetName: 'FormSstApply',
                          cells: {
                            activityStartDate: (fieldObject: any, row: any, value: any) => {
                              if (value) {
                                return wdiCore.Date.DateToString(row.activityStartDate);
                              } else {
                                return wdiCore.Date.DateToString(row.activityStartDateSa);
                              }
                            },
                            activityEndDate: (fieldObject: any, row: any, value: any) => {
                              if (value) {
                                return wdiCore.Date.DateToString(row.activityEndDate);
                              } else {
                                return wdiCore.Date.DateToString(row.activityEndDateSa);
                              }
                            },
                            supplyStartDate: (fieldObject: any, row: any, value: any) => {
                              if (value) {
                                return wdiCore.Date.DateToString(row.supplyStartDate);
                              } else {
                                return wdiCore.Date.DateToString(row.supplyStartDateSa);
                              }
                            },
                            supplyEndDate: (fieldObject: any, row: any, value: any) => {
                              if (value) {
                                return wdiCore.Date.DateToString(row.supplyEndDate);
                              } else {
                                return wdiCore.Date.DateToString(row.supplyEndDateSa);
                              }
                            },
                          }
                        };
                        toExcel({
                          name: '费用明细信息_' + wdiCore.Date.ToString(new Date()) + '.xlsx',
                          sheetProps: [sheet],
                        });
                      });
                      e.stopPropagation();
                    }} style={{float: 'right', marginRight: 10}}>
                      导出
                    </Button>
                  </>
                }
      >
        {isLoaded && <DetailGrid params={data}  {...pageGridSettings} />}
      </WdiPanel>
    </>
  );
}

export type DetailForGroupProps = {
  formId: number,
}

export const GeneralSettleDetailsGroupForApprovalApp: React.FC<DetailForGroupProps> = (props) => {
  /// Grid初始化配置，GridSettings请求完数据之后再进行加载
  const [isLoaded, setIsLoaded] = useState(false);
  const [gridSettings, setGridSettings] = useState<any>({});

  useEffect(() => {
    GridApi.searchConfig({id: 'SSDetailGroup', allowModifyColumns: true}).then((response) => {
      const settings: any = Object.assign({}, response.data, {
        actionsAlign: NsGrid.ActionsAlign.None,
        dataLoading: async (params: any) => {
          return await FormSs.getFormSsDetailsGroup(Object.assign({}, params));
        },
        queryParamaters: {
          formId: props.formId
        },
        additionalColumns: ["amountSa", "amount"]
      });

      setGridSettings(settings);
      setIsLoaded(true);
    });
  }, []);

  const pageGridSettings = Object.assign({}, gridSettings);
  pageGridSettings.antdProps = {
    pagination: {
      defaultPageSize: 10,
      showSizeChanger: true
    }
  };

  return (
    <WdiPanel title={<WdiCardTitle iconType={Enum.IconType.DETAIL_INFO} title='费用统计信息'/>} collapsed={true}>
      {isLoaded && <GroupDetailGrid {...pageGridSettings} />}
    </WdiPanel>
  );
};
